import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { OppsFilled } from "@assets";
import { ModalLabel, ModalTitle, Button } from "./ErrorModal.style";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-title {
    text-align: center;
    /* color: #73217d; */
  }

  .ant-modal-content {
    text-align: center;
  }

  .ant-modal-footer {
    text-align: center;

    .ant-btn-default {
      display: none !important;
    }
  }
`;

const ErrorModal = ({ open, onOk, label, title }) => {
  const { t } = useTranslation()

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      open={open}
      width={320}
      onOk={onOk}
      footer={null}
      style={{
        textAlign: "center",
      }}
    >
      <ModalTitle>{title}</ModalTitle>
      <OppsFilled width={80} height={80} />
      <ModalLabel>{label}</ModalLabel>
      <Button type="primary" onClick={onOk}>
        {t("common.ok")}
      </Button>
    </Modal>
  );
};

export default ErrorModal;
